import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import About from "@/components/About";
import AboutArabookverse from "@/components/AboutArabookverse";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import { LoginForm, RegisterForm } from "@/features/auth";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useAuth } from "@/contexts/AuthContext";

const Index = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showAuth, setShowAuth] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.get("login") === "true") {
      setShowAuth(true);
      setIsLogin(true);
    } else if (searchParams.get("register") === "true") {
      setShowAuth(true);
      setIsLogin(false);
    }
  }, [searchParams]);

  useEffect(() => {
    if (isAuthenticated && showAuth) {
      setShowAuth(false);
      setSearchParams({});
      navigate("/cms/dashboard");
    }
  }, [isAuthenticated, showAuth, navigate, setSearchParams]);

  const handleCloseAuth = () => {
    setShowAuth(false);
    setSearchParams({});
  };

  const toggleAuthForm = () => {
    setIsLogin(!isLogin);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <HowItWorks />
      <Services />
      <About />
      <AboutArabookverse />
      <Contact />
      <Footer />

      <Dialog open={showAuth} onOpenChange={handleCloseAuth}>
        <DialogContent className="sm:max-w-md">
          {isLogin ? (
            <LoginForm onToggleForm={toggleAuthForm} />
          ) : (
            <RegisterForm onToggleForm={toggleAuthForm} />
          )}
        </DialogContent>
      </Dialog>

      <Chatbot />
    </div>
  );
};

export default Index;
